unit App.Shared;

interface

uses
  Sphinx.Consts;

type

{ TODO : Change CATSC to a unique indicator for this implementation }

{$SCOPEDENUMS ON}
  // TODO -oAFP: can we use generic (None, Admin, User, Manager, System) ??
  TUserScope = (
    None,
    ReadOnly,
    User,
    AdminUser,
    Administrator,
    SuperUser,
    Customer,
    ManagerApp
  );

const
  // TODO -oAFP: can we use generic ('NONE', 'ADMIN', 'USER', 'MANAGER', 'SYSTEM') ??
  // todo -oAFP: taken from smx.auth.shared, since that's what the server is returning
  USER_SCOPES: array [TUserScope] of string = (
    'None',
    'ReadOnly',
    'User',
    'AdminUser',
    'Administrator',
    'SuperUser',
    'Customer',
    'ManagerApp'
  );

  CLAIM_SCOPE = 'scope';

  SCOPE_NONE = 'NONE';
  SCOPE_USER = 'USER';

  App_Name = 'CATSC';
  App_Manager_Scope = App_Name + '_MANAGER';
  App_Web_App_Id = App_Name + '_WEB';
  {$IFDEF RELEASE}
  Web_Redirect_URL = '';
  {$ELSE}
  Web_Redirect_URL = 'http://localhost:8000/CATSCWeb/Index.html';
  {$ENDIF}


function IsValidScope(const Value: string): Boolean;
function StrToUserScope(const Value: string): TUserScope;

implementation

uses Rtti;

function IsValidScope(const Value: string): Boolean;
var I: TUserScope;
begin
  result := False;
  for I := Low(TUserScope) to High(TUserScope) do
  begin
    if USER_SCOPES[I] = Value then
       Exit(True);
  end;
end;

function StrToUserScope(const Value: string): TUserScope;
begin
  Result := TRttiEnumerationType.GetValue<TUserScope>(Value);
end;

{$SCOPEDENUMS OFF}

end.
